export function AlertOnlineDotsOnlineBlinking() {
  return (
    <div className="bg-clover-500 relative z-[3] flex h-2 w-2 self-center rounded-full">
      <div className="bg-clover-500 absolute z-[3] flex h-2 w-2 animate-ping self-center rounded-full" />
    </div>
  )
}
